import React from 'react';
import { Users, Star, Clock } from 'lucide-react';
import avatar1 from '@/assets/avatar-1.jpg';
import avatar2 from '@/assets/avatar-2.jpg';
import avatar3 from '@/assets/avatar-3.jpg';
import avatar4 from '@/assets/avatar-4.jpg';
import avatar5 from '@/assets/avatar-5.jpg';

interface SocialProofBarProps {
  monthlyUsers?: number;
  activeSessions?: number;
  className?: string;
}

const SocialProofBar: React.FC<SocialProofBarProps> = ({
  monthlyUsers = 50000,
  activeSessions = 327,
  className = ''
}) => {
  return (
    <div className={`bg-accent/20 border-y border-border ${className}`}>
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* User Avatars + Text */}
          <div className="flex items-center gap-4">
            <div className="flex -space-x-3">
              {[avatar1, avatar2, avatar3, avatar4, avatar5].map((avatar, i) => (
                <img
                  key={i}
                  src={avatar}
                  alt={`Happy patient ${i + 1}`}
                  className="w-10 h-10 rounded-full border-2 border-background object-cover"
                />
              ))}
            </div>
            <p className="text-sm md:text-base text-foreground font-medium">
              Join <span className="font-bold text-primary">{monthlyUsers.toLocaleString()}+</span> people who found their therapist this month
            </p>
          </div>
          
          {/* Live Stats */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <div className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
              </div>
              <span className="text-sm font-semibold text-foreground">
                {activeSessions} sessions happening now
              </span>
            </div>
            
            <div className="flex items-center gap-2 text-yellow-500">
              <Star className="w-4 h-4 fill-current" />
              <span className="text-sm font-semibold text-foreground">4.8/5</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialProofBar;
